'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Left = require('./Left');

var _Left2 = _interopRequireDefault(_Left);

var _Right = require('./Right');

var _Right2 = _interopRequireDefault(_Right);

var _DoubleRight = require('./DoubleRight');

var _DoubleRight2 = _interopRequireDefault(_DoubleRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = { Left: _Left2.default, Right: _Right2.default, DoubleRight: _DoubleRight2.default };


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Chevron/index.js
// module id = 191
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16